import { render } from "./Navigation.vue?vue&type=template&id=c0baa4fe&scoped=true"
import script from "./Navigation.vue?vue&type=script&lang=js"
export * from "./Navigation.vue?vue&type=script&lang=js"

import "./Navigation.vue?vue&type=style&index=0&id=c0baa4fe&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c0baa4fe"

export default script